// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreatePluginRequestPayload,
  TCreatePluginResponsePayload,
  TDeletePluginRequestPayload,
  TDeletePluginResponsePayload,
  TListPluginsRequestPayload,
  TListPluginsResponsePayload,
  TListToolsRequestPayload,
  TListToolsResponsePayload,
  TUpdatePluginRequestPayload,
  TUpdatePluginResponsePayload,
  TUploadPluginFileRequest,
  TUploadPluginFileResponsePayload,
} from './plugins.types.ts';

export const createPluginsApi = (transport: TApiTransport) => ({
  /** Creates a plugin */
  createPlugin: (
    payload: TCreatePluginRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TCreatePluginRequestPayload, TCreatePluginResponsePayload>(
      '/create_plugin',
      payload,
      options,
    ),

  /** Deletes a plugin */
  deletePlugin: (
    payload: TDeletePluginRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TDeletePluginRequestPayload, TDeletePluginResponsePayload>(
      '/delete_plugin',
      payload,
      options,
    ),

  /** Lists plugins */
  listPlugins: (
    payload: TListPluginsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TListPluginsRequestPayload, TListPluginsResponsePayload>(
      '/list_plugins',
      payload,
      options,
    ),

  /** Lists available tools */
  listTools: (
    payload: TListToolsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TListToolsRequestPayload, TListToolsResponsePayload>(
      '/list_tools',
      payload,
      options,
    ),

  /** Updates a plugin */
  updatePlugin: (
    payload: TUpdatePluginRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TUpdatePluginRequestPayload, TUpdatePluginResponsePayload>(
      '/update_plugin',
      payload,
      options,
    ),

  /** Uploads a file that can be attached to plugins */
  uploadPluginFile: (
    payload: TUploadPluginFileRequest,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TUploadPluginFileRequest, TUploadPluginFileResponsePayload>(
      '/upload_plugin_file',
      payload,
      { ...options, contentType: 'multipart/form-data' },
    ),
});
